import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable, filter, map, switchMap, take } from 'rxjs';
import { selectConfig } from '../store/selectors/config.selector';

interface PresignUploadResponse {
  upload_url: string;
  key: string;
  filename: string;
  bucket: string;
  method: string;
  headers: Record<string, string>;
  content_type: string;
}

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private httpNoInterceptor: HttpClient;

  constructor(
    private http: HttpClient,
    private store: Store,
    httpBackend: HttpBackend
  ) {
    this.httpNoInterceptor = new HttpClient(httpBackend);
  }

  uploadImage(formId: string, versionId: string, valueId: string, file: File): Observable<string> {
    return this.store.select(selectConfig).pipe(
      filter((config) => !!config.data['FORM_API']),
      take(1),
      switchMap((config) => {
        const formApi = config.data['FORM_API'];
        const presignUrl = `${formApi}/forms/${formId}/versions/${versionId}/values/${valueId}/files/presign-upload`;

        return this.http
          .post<PresignUploadResponse>(presignUrl, {
            filename: file.name,
            content_type: file.type,
          })
          .pipe(
            switchMap((response) => {
              const headers = new HttpHeaders(response.headers);
              return this.httpNoInterceptor
                .put(response.upload_url, file, { headers })
                .pipe(
                  map(
                    () =>
                      `${formApi}/files/presign-download?key=${encodeURIComponent(response.key)}&redirect=true`
                  )
                );
            })
          );
      })
    );
  }
}
